var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { attrs: { lg: 7, md: 9, sm: 12, span: 6, xl: 6, xs: 24 } },
            [
              _c("img", {
                staticStyle: { width: "100%" },
                attrs: { src: "images/anze-product.png" },
              }),
            ]
          ),
          _c(
            "el-col",
            { attrs: { lg: 16, md: 14, sm: 12, span: 18, xl: 18, xs: 24 } },
            [
              _c(
                "div",
                { staticStyle: { "margin-left": "16px" } },
                [
                  _c("h2", [
                    _vm._v("\n\t\t\t\t\t泰康\n\t\t\t\t\t"),
                    _c("span", { staticStyle: { color: "red" } }, [
                      _vm._v("建筑行业"),
                    ]),
                    _vm._v("\n\t\t\t\t\t安责险\n\t\t\t\t"),
                  ]),
                  _c("div", { staticStyle: { color: "red" } }, [
                    _vm._v("建筑行业 | 行业超低价 | 全线上操作"),
                  ]),
                  _c("p", [
                    _vm._v("\n\t\t\t\t\t① 投保简便支持月单\n\t\t\t\t\t"),
                    _c("br"),
                    _vm._v("\n\t\t\t\t\t② 社保用药100%赔付\n\t\t\t\t\t"),
                    _c("br"),
                    _vm._v("\n\t\t\t\t\t③ 3人起保,最高可保120万\n\t\t\t\t\t"),
                    _c("br"),
                  ]),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "medium", type: "warning" },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.handleInsure.apply(null, arguments)
                        },
                      },
                    },
                    [_vm._v("立即投保")]
                  ),
                  _c("br"),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-top": "25px" },
                      attrs: {
                        loading: _vm.isDownLoading,
                        icon: "el-icon-download",
                        size: "medium",
                        type: "text",
                      },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.handleDownLoad.apply(null, arguments)
                        },
                      },
                    },
                    [_vm._v("\n\t\t\t\t\t下载泰康险职业类别表\n\t\t\t\t")]
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _c(
        "el-tabs",
        {
          model: {
            value: _vm.currentStep,
            callback: function ($$v) {
              _vm.currentStep = $$v
            },
            expression: "currentStep",
          },
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: "保险详情", name: "0" } },
            [
              _c(
                "el-card",
                [
                  _c(
                    "div",
                    { staticClass: "u-m-b-20" },
                    [
                      _vm._v("\n\t\t\t\t\t方案：\n\t\t\t\t\t"),
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: "请选择方案" },
                          model: {
                            value: _vm.planData,
                            callback: function ($$v) {
                              _vm.planData = $$v
                            },
                            expression: "planData",
                          },
                        },
                        _vm._l(_vm.planDataList, function (item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.label, value: item.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c("avue-crud", {
                    ref: "plan",
                    attrs: {
                      data: _vm.getFormData,
                      option: _vm.optionPlan,
                      "span-method": _vm.spanMethodPlan,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "常见问题", name: "1" } },
            [
              _c(
                "el-row",
                [
                  _c("el-col", { attrs: { span: 20 } }, [
                    _c(
                      "ul",
                      _vm._l(_vm.dataQA, function (qa) {
                        return _c(
                          "li",
                          { key: qa.question },
                          [
                            _c("div", [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    display: "inline-block",
                                    width: "20px",
                                    "text-align": "center",
                                    "background-color": "MediumPurple",
                                    color: "white",
                                    padding: "4px",
                                    "border-radius": "4px",
                                    "margin-right": "8px",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t\tQ\n\t\t\t\t\t\t\t\t"
                                  ),
                                ]
                              ),
                              _c(
                                "span",
                                { staticStyle: { "font-weight": "bold" } },
                                [_vm._v(_vm._s(qa.question))]
                              ),
                            ]),
                            _c("p"),
                            _c("div", [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    display: "inline-block",
                                    width: "20px",
                                    "background-color": "MediumSeaGreen",
                                    color: "white",
                                    padding: "4px",
                                    "border-radius": "4px",
                                    "margin-right": "8px",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t\tA\n\t\t\t\t\t\t\t\t"
                                  ),
                                ]
                              ),
                              _c(
                                "span",
                                { staticStyle: { "white-space": "pre-wrap" } },
                                [_vm._v(_vm._s(qa.answer))]
                              ),
                            ]),
                            _c("el-divider"),
                          ],
                          1
                        )
                      }),
                      0
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "投保须知", name: "2" } },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 20 } },
                    [
                      _c("h3", [_vm._v("保险条款及须知")]),
                      _c("p", { staticStyle: { "line-height": "32px" } }, [
                        _vm._v(
                          "\n\t\t\t\t\t\t1. 本保险适用以下保险条款\n\t\t\t\t\t\t"
                        ),
                        _c("br"),
                        _c("span", { staticClass: "link" }, [
                          _c(
                            "a",
                            {
                              staticStyle: { color: "DodgerBlue" },
                              attrs: {
                                href: "azxclause.html",
                                target: "_blank",
                              },
                            },
                            [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t\t泰康在线财产保险股份有限公司安全生产责任保险条款\n\t\t\t\t\t\t\t"
                              ),
                            ]
                          ),
                          _vm._v(
                            "\n\t\t\t\t\t\t\t备案编号为：(泰康在线)(备-责任保险)【2021】(主) 005号\n\t\t\t\t\t\t"
                          ),
                        ]),
                        _vm._v(
                          "\n\t\t\t\t\t\t2、本保险由泰康在线财产保险股份有限公司承保，承保区域为全国范围（港澳台除外）。\n\t\t\t\t\t\t"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t\t3、保险公司全国统一的客户服务及投诉方式详见如下链接：\n\t\t\t\t\t\t"
                        ),
                        _c("br"),
                        _c("span", { staticClass: "link" }, [
                          _c(
                            "a",
                            {
                              staticStyle: { color: "DodgerBlue" },
                              attrs: {
                                href: "http://www.tk.cn/sales/feedback-pc/page/",
                                target: "_blank",
                              },
                            },
                            [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t\t全国统一的客户服务及投诉方式\n\t\t\t\t\t\t\t"
                              ),
                            ]
                          ),
                        ]),
                        _vm._v(
                          "\n\t\t\t\t\t\t4、在投保本保险前请您认真阅读《保险条款》，了解本保险的保险责任及责任免除，尤其是对其中免除保险人责任的条款(包括但不限于责任免除、投保人被保险人义务等)。在充分理解并接受上述内容的基础上，同意以此作为订立保险合同的依据。\n\t\t\t\t\t\t"
                        ),
                        _c("br"),
                        _vm._v("\n\t\t\t\t\t\t5、\n\t\t\t\t\t\t"),
                        _c("span", { staticClass: "red-bold" }, [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t在投保本保险时您应如实填写各项投保信息以履行相应的如实告知义务，若故意或者因重大过失未履行如实告知义务，足以影响保险公司决定是否同意承保或者提高保险费率的，保险公司有权解除合同；故意不履行如实告知义务的，保险公司对于合同解除前发生的保险事故，不承担赔偿责任，并不退还保险费；因重大过失未履行如实告知义务，对保险事故的发生有严重影响的，保险公司对于合同解除前发生的保险事故，不承担赔偿责任，并不退还保险费。\n\t\t\t\t\t\t"
                          ),
                        ]),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t\t6、本保险合同以电子保单形式提供。根据《中华人民共和国民法典》规定，数据电文是合法的合同表现形式，与纸质合同具有同样的法律效力。\n\t\t\t\t\t\t"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t\t7、本保险根据投保单位的需求提供电子发票或纸质专票。\n\t\t\t\t\t\t"
                        ),
                        _c("br"),
                        _vm._v("\n\t\t\t\t\t\t8、\n\t\t\t\t\t\t"),
                        _c("span", { staticClass: "red-bold" }, [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t本保险由博维保险经纪有限公司面向全国销售并提供服务，如有其他疑问，请在投保前联系客服热线400-180-1616进行咨询与确认。\n\t\t\t\t\t\t"
                          ),
                        ]),
                        _c("br"),
                      ]),
                      _c("el-divider"),
                      _c("h3", [_vm._v("特别约定")]),
                      _c(
                        "div",
                        { staticStyle: { "white-space": "pre-line" } },
                        [
                          _vm._v("\n\t\t\t\t\t\t1.\n\t\t\t\t\t\t"),
                          _c("span", { staticClass: "red-bold" }, [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t本产品仅限在中国大陆注册的合法机构购买，实际经营地址在以下地区的单位本产品不予承保：青海省、新疆维吾尔自治区、西藏自治区、四川省甘孜藏族自治州，阿坝藏族羌族自治州、凉山彝族自治州、天津市、山东省临沂市。\n\t\t\t\t\t\t"
                            ),
                          ]),
                          _vm._v("\n\t\t\t\t\t\t2.\n\t\t\t\t\t\t"),
                          _c("span", { staticClass: "red-bold" }, [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t本产品可加人，按天收费，不可减人。保险期限1-3个月的保单不可替换，保险期限3个月以上的保单可替换，4类职业人员只能替换为新的4类职业人员，5-6类职业人员只能替换为新5-6类职业人员。\n\t\t\t\t\t\t"
                            ),
                          ]),
                          _vm._v(
                            "\n\t\t\t\t\t\t3.被保险人雇员的年龄限16-65周岁（不超65），本方案每人限投1份，超过部分无效。\n\t\t\t\t\t\t在保险期间内，被保险人在保险单载明的场所和区域范围内从事生产、储存、经营等活动过程中，因发生生产安全事故（指被保险人在生产经营活动过程中发生的人员伤亡事故，不包括自然灾害）导致其雇员或第三者死亡或伤残，依照中华人民共和国法律（不包括港、澳、台地区法律）应由被保险人承担的经济赔偿责任，保险人按照本保险合同的约定负责赔偿。\n\t\t\t\t\t\t4.累计事故责任限额：500万（10人及以下）/1000万（大于10人）\n\t\t\t\t\t\t每次事故责任限额：200万（10人及以下）/500万（大于10人） 每次事故及累计事故法律费用责任限额：10万\n\t\t\t\t\t\t每次事故及累计事故救援费用责任限额：10万 累计事故第三者人员伤亡责任限额：30万\n\t\t\t\t\t\t每次事故第三者人员伤亡责任限额：10万 5.雇员是指与\n\t\t\t\t\t\t"
                          ),
                          _c("span", { staticClass: "red-bold" }, [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t被保险人存在劳动关系（包括事实劳动关系）的各种用工形式、各种用工期限的劳动者及个体工商户的经营者本人，个体工商户经营者的直系亲属在生产经营活动中视为雇员。出险时保险人有权要求被保险人提供前述关系的证明，包括但不限于劳动合同、劳务合同、工资发放流水或打卡记录等材料。\n\t\t\t\t\t\t"
                            ),
                          ]),
                          _vm._v(
                            "\n\t\t\t\t\t\t6.本保单拒绝承保职业：\n\t\t\t\t\t\t"
                          ),
                          _c("span", { staticClass: "red-bold" }, [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t地下（露天打桩和挖地基除外）/水下/水上作业、渔业、船舶相关工作、邮政/快递/航空/水上运输业、地质矿产/石油/天然气/采石业、凿岩工、森林砍伐/防火人员、驯兽师、动物饲养、塔吊安装拆除和维修、窑炉/烟囱新建和拆除、高炉炉前/运转工人、钢缆生产加工、钢丝绳生产加工、石棉制造、水泥制造、化工/军工/火工相关工作、水电工（地下）、涉及危险品/有毒物品/防化器/烟花爆竹/火药/炸药/枪炮/爆破的相关工作、保镖、特种兵/军人/武警/公安/警察/消防等治安人员、警校/军校、体育运动、记者、演艺/娱乐业、各式垃圾处理场的场主和操作人员（包括但不限于垃圾堆、焚烧厂和有毒废物处理厂的承包商）、家具行业、楼宇拆除、桥隧工人、钢结构安装工/钢骨结构工人/钢架架设工人。\n\t\t\t\t\t\t"
                            ),
                          ]),
                          _vm._v(
                            "\n\t\t\t\t\t\t7.被保险人雇员遭受伤害时，实际从事的工作（不属于拒绝承保职业）危险程度高于投保职业或营业范围的，则保险人对按保单约定的应承担的保险责任，免赔30%。从事高处作业的，必须投保5-6类职业。高处作业以《高处作业分级标准》（中华人民共和国国家标准GB3608-2008）中的定义为准，\n\t\t\t\t\t\t"
                          ),
                          _c("span", { staticClass: "red-bold" }, [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t高处作业定义：凡在坠落高度基准面2m以上（含2m）有可能坠落的高处进行作业，都称为高处作业。\n\t\t\t\t\t\t"
                            ),
                          ]),
                          _vm._v(
                            "\n\t\t\t\t\t\t如属于拒绝承保职业，保险人不承担任何赔偿责任。\n\t\t\t\t\t\t8.以下情形，保险人不得以投保职业有误而拒赔或者减少承担赔偿责任：投保职业对应的保费，大于或等于被保险人实际职业对应的保费。\n\t\t\t\t\t\t9.\n\t\t\t\t\t\t"
                          ),
                          _c("span", { staticClass: "red-bold" }, [
                            _vm._v("以下四种情况均不属于保险责任。"),
                          ]),
                          _vm._v("\n\t\t\t\t\t\t（1）\n\t\t\t\t\t\t"),
                          _c("span", { staticClass: "red-bold" }, [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t被保险人或其代表、雇用人员使用机动车辆造成第三者人身伤亡或财产损失的赔偿责任；\n\t\t\t\t\t\t"
                            ),
                          ]),
                          _vm._v("\n\t\t\t\t\t\t（2）\n\t\t\t\t\t\t"),
                          _c("span", { staticClass: "red-bold" }, [
                            _vm._v(
                              "各种职业病、疾病、中暑、猝死等非意外事故；"
                            ),
                          ]),
                          _vm._v("\n\t\t\t\t\t\t（3）\n\t\t\t\t\t\t"),
                          _c("span", { staticClass: "red-bold" }, [
                            _vm._v("被保险人及其雇员、第三者的财产损失；"),
                          ]),
                          _vm._v("\n\t\t\t\t\t\t（4）\n\t\t\t\t\t\t"),
                          _c("span", { staticClass: "red-bold" }, [
                            _vm._v(
                              "雇员在上下班途中，受到的交通及意外事故伤害；"
                            ),
                          ]),
                          _vm._v(
                            "\n\t\t\t\t\t\t10.\n\t\t\t\t\t\t发生本保险责任范围内的生产安全事故，造成被保险人雇员及第三者人身伤亡的，对被保险人依法应承担的经济赔偿责任，保险人依照以下约定负责赔偿：\n\t\t\t\t\t\t（1）\n\t\t\t\t\t\t"
                          ),
                          _c("span", { staticClass: "red-bold" }, [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t死亡：被保险人雇员发生死亡时，保险人按工伤赔偿标准核算身故赔偿金；第三者发生死亡时按《最高人民法院关于审理人身损害赔偿案件适用法律若干问题的解释》在保险合同约定的每人限额内核算身故赔偿金。\n\t\t\t\t\t\t"
                            ),
                          ]),
                          _vm.planData === 0
                            ? [
                                _vm._v(
                                  "\n\t\t\t\t\t\t\t（2）伤残：如被保险人雇员遭遇保险事故导致伤残，每人可从保险人获得的伤残赔偿金=雇员每人伤残赔偿限额*伤残等级对应的赔付比例；如被保险人发生保险事故导致第三者伤残，每人可从保险人获得的伤残赔偿金=第三者每人伤残赔偿限额*伤残等级对应的赔付比例。按伤残鉴定机构出具的伤残程度鉴定书，并对照\n\t\t\t\t\t\t\t"
                                ),
                                _c("span", { staticClass: "red-bold" }, [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t《人体损伤致残程度分级》（2017年1月1日起施行版本）确定伤残等级而支付相应赔偿金，伤残程度为永久丧失工作能力或一级伤残给付比例100%，二级伤残给付比例90%，三级伤残给付比例80%，四级伤残给付比例70%，五级伤残给付比例60%，六级伤残给付比例30%，七级伤残给付比例20%，八级伤残给付比例15%，九级伤残给付比例7%，十级伤残给付比例5%。\n\t\t\t\t\t\t\t"
                                  ),
                                ]),
                              ]
                            : [
                                _vm._v(
                                  "\n\t\t\t\t\t\t\t（2）伤残：如被保险人雇员遭遇保险事故导致伤残，每人可从保险人获得的伤残赔偿金=雇员每人伤残赔偿限额*伤残等级对应的赔付比例。按伤残鉴定机构出具的伤残程度鉴定书，并对照国家发布的\n\t\t\t\t\t\t\t"
                                ),
                                _c("span", { staticClass: "red-bold" }, [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t《劳动能力鉴定职工工伤与职业病致残等级》（GB/T16180-2014）确定伤残等级而支付相应赔偿金，伤残程度为永久丧失工作能力或一级伤残给付比例100%，二级伤残给付比例90%，三级伤残给付比例80%，四级伤残给付比例70%，五级伤残给付比例60%，六级伤残给付比例30%，七级伤残给付比例20%，八级伤残给付比例15%，九级伤残给付比例7%，十级伤残给付比例5%。\n\t\t\t\t\t\t\t"
                                  ),
                                ]),
                                _c("br"),
                              ],
                          _vm._v(
                            "\n\t\t\t\t\t\t（3）被保险人不得就其单个雇员因同一保险事故同时申请伤残赔偿金和死亡赔偿金。 11.就每次事故\n\t\t\t\t\t\t"
                          ),
                          _c("span", { staticClass: "red-bold" }, [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t被保险人对每名雇员承担的治疗费用赔偿责任，保险人按照《工伤保险条例》及相关司法解释规定的标准为准据实计算，每次事故免赔200元后，社保用药100%赔付；对第三者承担的治疗费用赔偿责任，保险人按照《最高人民法院管理审理人身损害赔偿案件适用法律若干问题的解释》规定的标准，按每次事故200元免赔额，社保用药100%赔付后，\n\t\t\t\t\t\t"
                            ),
                          ]),
                          _vm._v(
                            "\n\t\t\t\t\t\t在保险合同约定的每次事故每人医疗费用责任限额内进行赔偿。\n\t\t\t\t\t\t12.误工费用适用独立的赔偿限额，不包含在身故、伤残及医疗费用赔偿限额之内。\n\t\t\t\t\t\t"
                          ),
                          _c("span", { staticClass: "red-bold" }, [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t按100元/天的标准赔偿误工费，每人每次事故最高赔偿90天，累计不超过180天。误工费的计算包含住院期间、出院后的休息误工时间，其中出院后的休息误工时间取医嘱建休时间、实际误工时间及GAT1193-2014《人身损害误工期、护理期、营养期评定规范》规定标准三者中的最短时间，且一旦确定伤残程度后即刻停止误工费的计算。被保险人雇员仅需门诊治疗的，按本保单约定无误工费赔付。本保单误工费赔付仅适用被保险人雇员，第三者无误工费赔付。\n\t\t\t\t\t\t"
                            ),
                          ]),
                          _vm._v("\n\t\t\t\t\t\t13.\n\t\t\t\t\t\t"),
                          _c("span", { staticClass: "red-bold" }, [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t本保单指定就诊医院为大陆境内二级及以上公立医院。如因紧急抢救无法前往本保单指定就诊医院，须在保险事故发生后72小时内转入本保单指定就诊医院。对于前往非本保单指定就诊医院或未按本约定转入本保单指定就诊医院所产生的医疗费用，保险人对按保单约定的应承担的保险责任，免赔20%。\n\t\t\t\t\t\t"
                            ),
                          ]),
                          _vm._v("\n\t\t\t\t\t\t14.\n\t\t\t\t\t\t"),
                          _c("span", { staticClass: "red-bold" }, [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t被保险人必须在保险事故发生后48小时内报案，因延迟报案影响保险人查勘、定损的，保险人对无法核实部分不承担任何赔偿责任。如果被保险人超过72小时才报案，则保险人对按保单约定的应承担的保险责任，免赔50%。\n\t\t\t\t\t\t"
                            ),
                          ]),
                          _vm._v(
                            "\n\t\t\t\t\t\t如果事故发生日期早于本保单生效日期，被保险人通过对事故发生日期造假的方式，从而在本保单提出索赔的行为则属于骗保，保险人有权提请相关机关追究被保险人及相关人员的法律责任。\n\t\t\t\t\t\t15.\n\t\t\t\t\t\t"
                          ),
                          _c("span", { staticClass: "red-bold" }, [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t本保单累计死亡人数2人（含）及以上的，须提供安监证明，否则保险人有权不承担赔偿责任。\n\t\t\t\t\t\t"
                            ),
                          ]),
                          _vm._v("\n\t\t\t\t\t\t16.\n\t\t\t\t\t\t"),
                          _c("span", { staticClass: "red-bold" }, [
                            _vm._v(
                              "从事高处作业必须取得有效高处作业证且佩戴安全带"
                            ),
                          ]),
                          _vm._v("\n\t\t\t\t\t\t，否则发生\n\t\t\t\t\t\t"),
                          _c("span", { staticClass: "red-bold" }, [
                            _vm._v(
                              "身故或伤残事故，保险人对按保单约定的应承担的保险责任免赔25%。"
                            ),
                          ]),
                          _vm._v(
                            "\n\t\t\t\t\t\t保险人对其他特种作业人员（除高处作业）无要求持有特种作业操作证。高处作业证必须由应急管理部门颁发。\n\t\t\t\t\t\t17.如不幸发生事故，您可以通过以下两种途径进行报案： （1）拨打泰康在线官方理赔客服电话95522-3；\n\t\t\t\t\t\t（2）也可通过微信小程序“线上快赔”上传出险照片报案，需要报案服务咨询或咨询保险相关事宜，可拨打经纪公司服务热线：400-180-1616，获取工作人员的帮助，取得报案号后才是报案成功（否则报案失败）。\n\t\t\t\t\t"
                          ),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }